<template>
	<div class="plus_d " style="">
		<Tou></Tou>
		<div class="w1500 pl-6 pr-6 pb-126">
			<div class="f-34 ys-33 mt-70 montserRegular">{{gudingziduan.plus.Goodmorning}},{{getProcessedNickname(users.nickname)}}! </div>
			
			<div class="gonggao flex mb-40 mt-14">
				<div class="gonggao1 br-50 flex a-center j-center mr-17"> <span
						class="iconfont tit-25 ys-0 icon-gonggao2"></span> </div>
				<div style="flex: 1;" class="slide" v-if="messageList && messageList.length>0">
					<el-carousel height="30px" :autoplay="false" arrow="always">
						<el-carousel-item v-for="(item,i) in messageList" :key="i">
							<div class="tit-15 ys-66 h100 flex a-center text">{{item}}</div>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			<div class="flex j-between plus_zhu">
				<div class="plus_zhul mb-20">
					<div class="bj-0 br-15 mb-20">
						<div class="flex pl-63 pt-24 pr-63 pb-70 zhulTop">
							<!-- <el-image fit="contain" class="pz1" :src="require('@/assets/pc/plus/plus_d1.png')" alt="" v-if="infos.plusLevel=="/> -->
							
							<el-image fit="contain" class="pz1" :src="infos.plusImg" alt="" />

							<div class="pz2  ml-77 zhulTopInfo">
								<div class="tit-22 line-50 montserRegular">{{getProcessedNickname(users.nickname)}}</div>
								<div class="tit-16 line-30" style="color:#82858E;">{{gudingziduan.plus.Currentstatus}}: <span
										style="color:#323232;">{{getMedalType(infos.plusLevel)}}</span> </div>
								<div class="tit-16 line-30" style="color:#82858E;">{{gudingziduan.plus.SEMSOrganization}}: <span
										style="color:#323232;">{{users.organizationCode}}</span> </div>
								<div class="tit-16 line-30" style="color:#82858E;">{{gudingziduan.plus.Email}}: <span
										style="color:#323232;">{{users.account}}</span> </div>
								<div class="tit-16 line-30" style="color:#82858E;">{{gudingziduan.plus.Validuntil}}: <span
										style="color:#323232;">{{infos.plusExpirationDate}}</span> </div>
							</div>
						</div>
						<div class="pl-50 pr-70 pb-40 rel">
							<div class="progress">
								<el-image fit="contain" class="abs icon icon1 cur_pointer"
									:src="require('@/assets/pc/plus/plus_d3.png')" alt="" @click="$dakai('/user-Profile?type=4')"/>
								<el-image fit="contain" class="abs icon icon2 cur_pointer"
									:src="require('@/assets/pc/plus/plus_d2.png')" alt="" @click="$dakai('/user-Profile?type=4')"/>
								<el-progress :show-text="false" :percentage="infos.process>100?100:infos.process" color="#EB1820"></el-progress>
							</div>

							<div class="flex a-center j-between flex-wrap mt-16 mb-25">
								<!-- @click="$dakai('plus_detail')" -->
								<div  @click="$dakai('plus_detail')" class="tit-26 montserMedium cur_pointer" style="color: #E60012;"
									>{{infos.currentYearPointNum}} <span class="ys-33 ">{{gudingziduan.plus.pointsearned}}</span>
								</div>
								<div style="color: #82858E;" class="tit-14" v-if="yy!='PK'">{{gudingziduan.plus.Updatedatthe}}</div>
							</div>
							<div class="flex a-baseline mb-14" >
								<i class="el-icon-warning-outline tit-14" style="color:#EB1820;"></i>
								<span class="tit-14 ml-5" style="color: #82858E;">{{gudingziduan.plus.Clickonthe}}</span>
							</div>
							<div class="flex a-baseline"  v-if="yy!='PK'">
								<i class="el-icon-warning-outline tit-14" style="color:#EB1820;"></i>
								
								<span class="tit-14 ml-5" v-if="infos.plusLevel==0" style="color: #82858E;">{{gudingziduan.plus.putong[0]}} {{infos.silverPointNum}} {{gudingziduan.plus.putong[1]}} {{infos.goldPointNum}} {{gudingziduan.plus.putong[2]}}</span>
								<span class="tit-14 ml-5" v-if="infos.plusLevel==1" style="color: #82858E;">{{gudingziduan.plus.yinpai[0]}} {{infos.silverPointNum}} {{gudingziduan.plus.yinpai[1]}} {{infos.goldPointNum}} {{gudingziduan.plus.yinpai[2]}}</span>
								<span class="tit-14 ml-5" v-if="infos.plusLevel==2" style="color: #82858E;">{{gudingziduan.plus.jinpai[0]}} {{infos.silverPointNum}} {{gudingziduan.plus.jinpai[1]}} {{infos.goldPointNum}} {{gudingziduan.plus.jinpai[2]}}</span>
							</div>
						</div>
					</div>
					<div class="bj-0 br-15 pt-30 pb-40">
						<div class="tit-24 B-500 montserMedium ml-35 mb-40">Downloads area</div>
						<div class="flex downl">
							<div class="column item a-center flex w33 cur_pointer" @click="onMaterials">
								<img class="h70" src="../../../assets/pc/plus/plus_d4.png" alt="" />
								<span class="tit-16 ys-66 mt-15">{{gudingziduan.plus.Promotionalmaterials}}</span>
							</div>
							<div class="column item a-center flex w33 cur_pointer" @click="xiaZai">
								<img class="h70" src="../../../assets/pc/plus/plus_d5.png" alt="" />
								<span class="tit-16 ys-66 mt-15">{{gudingziduan.plus.Certificate}}</span>
							</div>
							<div class="column item a-center flex w33 cur_pointer" @click="onPoints">
								<img class="h70" src="../../../assets/pc/plus/plus_d6.png" alt="" />
								<span class="tit-16 ys-66 mt-15">{{gudingziduan.plus.Howtoearn}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="plus_zhur bj-0 br-15 mb-20">
					<div style="cursor: pointer;"  @click="$router.push({ name: 'collect_points'})" class="tit-24 B-500 ml-35 pt-60 mb-10 montserMedium" :class="gaise==1?'gaiyanse':''" v-if="gudingziduan.plus.RedeemyourGood2">{{gudingziduan.plus.RedeemyourGood2}}</div>
					<div class="tit-24 B-500 ml-35 pt-10 mb-40 montserMedium">{{gudingziduan.plus.RedeemyourGood}}</div>
					<vEchartss :infos="infos" :yuyan="gudingziduan.plus"></vEchartss>
				</div>
			</div>
			<div class="plus_db flex j-between">
				<div class="bj-0 br-15 plus_dbll">
					<div class="pt-47 pb-22 container">
						<div class="flex w100 j-between ">
							<div class="tit-26 B-500 pl-38 smTit montserMedium cur_pointer">
								Goodplus Forum</div>
							<div style="background: linear-gradient(-50deg,#e70a16 0%, #ff785c 100%); cursor: pointer;"
								class="ys-0 br-100 pt-10 pb-10 pl-20 pr-20 flex a-center mr-32 more1">
								<span class="tit-14 B-400 more mr-15 montserRegular cur_pointer" @click="$router.push({ name: 'forum'})">{{gudingziduan.plus.LearnMore}}</span>
								<span class="iconfont icon-arrow-right"></span>
							</div>
						</div>
						<ul class="pl-38 pr-38 ulss">
							<!-- ********* -->
							<li v-for="(l, i) in tiezilist" :key="l.id" class="cur_pointer pb-22 pt-25 " @click="xiangqing(l.id)"
								style="border-bottom: .01rem solid #F6F6F8;">
								<div class="flex j-between a-center">
									<div class="flex a-center">
										<div class="tit-16 flex a-center j-center"
											style="width: .25rem; height: .25rem; min-width:.25rem;min-height:.25rem;text-align: center;color: white;border-radius: 50%; flex-shrink: 0;"
											:style="getRandomGradients(l,i)">{{getFirstLetter(l.nickName?l.nickName:l.goodweId)}}</div>
										<div class="ys-33 tit-16 ml-18 mr-12 name" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; ">{{getProcessedNickname(l.nickName?l.nickName:l.goodweId)}}</div>
										<div class="tit-20 B-300 tit line1">{{ l.title }}</div>
									</div>
									<span class="tit-10 ys-9 pl-7 time">{{ l.createTime }}</span>
								</div>
								<div class="tit-15 zic-88 group-ht-nr mt-17 ys-9" v-html="l.content"></div>

							</li>
						</ul>
					</div>
				</div>
				<div class="bj-0 br-15 plus_dbrr">
					<div class="pt-47 pl-34 pr-33 pb-22">
						<div class="flex w100 j-between ">
							<div class="tit-24 B-500 smTit montserMedium cur_pointer" @click="$router.push({ name: 'Resource'})">Learning Lab </div>
							<div style="background: linear-gradient(-50deg,#e70a16 0%, #ff785c 100%); cursor: pointer;"
								class="ys-0 br-100 pt-10 pb-10 pl-20 pr-20 flex a-center more1">
								<span class="tit-14 B-400 more mr-15 montserRegular" @click="$router.push({ name: 'Resource'})">{{gudingziduan.plus.LearnMore}}</span>
								<span class="iconfont icon-arrow-right"></span>
							</div>
						</div>
						<ul class="pt-36">
							<li v-for="(l, i) in Playlistshu" :key="i" @click="resousedakai(l)" class="cur_pointer flex mb-25 a-center">
								<dd class="pd_tu br-5" style="overflow: hidden;">
									<el-image :src="l.image" class=""></el-image>
								</dd>
								<dd class="pl-22" style="flex: 1;display: -webkit-box; -webkit-line-clamp: 2;  -webkit-box-orient: vertical; overflow: hidden;">
									{{l.title}}
								</dd>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<Foot></Foot>
	</div>

</template>

<script>
import { plusInfo,plusMaterials,plussPoint,plusResource} from '@/api/plus.js';
import { Playlist,Playlistxq } from '@/api/resource.js';
import { plustie } from '@/api/forum.js';

import { allUser,message,userPdf } from '@/api/user.js';
import { tieziLie } from '@/api/forum.js'
import vEchartss from '../../../zuzuzu/huanxingtu.vue'
import Tou from '../../../zuzuzu/touss.vue'
import Foot from '../../../zuzuzu/foot.vue'
import {myxiangqing} from '@/api/Personal.js';
export default {
	data() {
		return {
			Playlistshu: [],
			pointimg: '',
			materials: '',
			users: {},
			infos: {},
			tiezilist:[],
			resourceList: [],
			huatilie: [
				{ title: 'Gw5000-DNS-30 what set up to get battery', createTime: "2024-7-25", commentNum: 60, thumbsUpNum: 6, latestReplyTime: '2024-10-08' },
				{ title: 'GW15K-SDT-30 and Power Limit', createTime: "2024-7-25 ", commentNum: 30, thumbsUpNum: 7, latestReplyTime: '2024-10-08' },
				{ title: 'Request Http', createTime: "2024-7-25 ", commentNum: 60, thumbsUpNum: 8, latestReplyTime: '2024-10-08' },
				{ title: 'SEMS+ launch notes', createTime: "2024-7-25 ", commentNum: 70, thumbsUpNum: 9, latestReplyTime: '2024-10-08' },
				{ title: 'Can inverter GW5000-DNS-30 be paired with a Goodwe Battery?', createTime: "2024-7-25", commentNum: 80, thumbsUpNum: 10, latestReplyTime: '2024-10-08' }
			],
			Groups: [
				{ tu: require('@/assets/pc/form1.png'), groupName: 'IoT Platforms', invitationNum: 30, replyNum: 20 },
				{ tu: require('@/assets/pc/form2.png'), groupName: 'Official Statement', invitationNum: 30, replyNum: 20 },
				{ tu: require('@/assets/pc/form3.png'), groupName: 'Activities', invitationNum: 30, replyNum: 20 },

			],
			plid: null,
			messageList: [],
			gradients:[
					['#FDEB71', '#F8D800'],
					['#ABDCFF', '#0396FF'],
					['#FEB692', '#EA5455'],
					['#CE9FFC', '#7367F0'],
					['#90F7EC', '#32CBCB'],
					['#FFF6B7', '#F6416C'],
					['#81FBB8', '#28C76F'],
					['#E2B0FF', '#9F44D3'],
					['#F97794', '#623AA2'],
					['#FCCF31', '#F55555'],
					['#F761A1', '#8C1BAB'],
					['#43CBFF', '#9708CC'],
					['#5EFCE8', '#736EFE'],
					['#FAD7A1', '#E96D71'],
					['#FFD26F', '#3677FF'],
					['#A0FE65', '#FA016D'],
					['#FFDB01', '#0E197D'],
					['#FEC163', '#DE4313'],
					['#92FFC0', '#002661'],
					['#EEAD92', '#6018DC'],
					['#F6CEEC', '#D939CD'],
					['#52E5E7', '#130CB7'],
					['#F1CA74', '#A64DB6'],
					['#E8D07A','#5312D6'],
					['#EECE13','#B210FF'],
					['#79F1A4','#0E5CAD'],
					['#FDD819','#E80505'],
					['#FFF3B0','#CA26FF'],
					['#FFF5C3','#9452A5'],
					['#F05F57','#360940'],
					['#2AFADF','#4C83FF'],
					['#FFF886','#F072B6'],
					['#97ABFF','#123597'],
					['#F5CBFF','#C346C2'],
					['#FFF720','#3CD500'],
					['#FF6FD8','#3813C2'],
					['#EE9AE5','#5961F9'],
					['#FFD3A5','#FD6585'],
					['#C2FFD8','#465EFB'],
					['#FD6585','#0D25B9'],
					['#FD6E6A','#FFC600'],
					['#65FDF0','#1D6FA3'],
					['#6B73FF','#000DFF'],
					['#FF7AF5','#513162'],
					['#F0FF00','#58CFFB'],
					['#FFE985','#FA742B'],
					['#FFA6B7','#1E2AD2'],
					['#FFAA85','#B3315F'],
					['#72EDF2','#5151E5'],
					['#FF9D6C','#BB4E75'],
					['#F6D242','#FF52E5'],
					['#69FF97','#00E4FF'],
					['#3B2667','#BC78EC'],
					['#70F570','#49C628'],
					['#3C8CE7','#00EAFF'],
					['#FAB2FF','#1904E5'],
					['#81FFEF','#F067B4'],
					['#FFA8A8','#FCFF00'],
					['#FFCF71','#2376DD'],
					['#FF96F9','#C32BAC'],
					// 这里可以添加更多的颜色组合  
				],
				colorCache: {}, // 新增缓存对象
				gudingziduan:{},
				gaise:0,
				yy:'',
		}
	},
	components: { Tou, Foot, vEchartss },
	watch: {
	    '$store.state.cunyuanyan': {
	      handler(newValue, oldValue) {
	        // console.log('语言已更新:', newValue);
	        this.gudingziduan=this.$store.state.cunyuanyan
			this.yy=this.$store.state.yuyan
			// console.log(this.gudingziduan,'plus_details')
	      },
	      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
	    }
	},
	created: function () {
		this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		this.gudingziduan=this.$store.state.cunyuanyan
		// console.log(this.gudingziduan,'plus')
	},
	mounted() {
		this.user2()
		this.CSH()
		// this.user()
		this.postTiezi()
		// this.postResource()
	},
	methods: {
		xiangqing(id) {
			this.$router.push({
				name: "details",
				params: { id: id }
			});
			// $dakai('details?id='+l.id)
		},
		getProcessedNickname(e) {
			if(e){
			  const atIndex =e.indexOf('@');
			  if(atIndex){
				return atIndex!== -1? e.slice(0, atIndex) : e;
			  }
			}
		},
		playlistlies(){
			Playlist({ "pageNum": 0,"pageSize": 5,"language":this.users.language,"country":this.users.country}).then(shu=>{
				// this.Playlistshu=shu.data.content
				this.plid = shu.data.content[0].id
				this.getPlaylists(this.plid)
				// this.zongshu=shu.data.totalPages
			})
		},
		resousedakai(e){
			// let urls=''
			// if(e.resourceType==1){
			// 	urls='/video-details'
			// }else if(e.resourceType==2){
			// 	urls='/blog-details'
			// }else if(e.resourceType==3){
			// 	urls='/webinar-details'
			// }
			// // console.log(e)
			// if(urls){
			// 	window.open('https://community.goodwe.com'+urls+'?id='+e.resourceId);
			// }
			const routeMap = {
				1: 'video-details',
				2: 'blog-details',
				3: 'webinar-details'
			};
			
			if(routeMap[e.resourceType]) {
				const route = this.$router.resolve({
					name: routeMap[e.resourceType],
					params: { id: e.resourceId }
				});
				window.open(route.href, '_blank');
			}
		},
		// getPlaylists(id) {、
		getPlaylists() {
			let par = {
			  "pageNum": 0,
			  "pageSize": 5,
			}
			plusResource(par).then(shu => {
				if(shu.code=='200') {
					this.Playlistshu = shu.data.content
				}
			})
			// Playlistxq(id).then(shu => {
			// 	console.log(shu,'ssssssss')
			// 	this.Playlistshu = shu.data.videos
			// })
		},
		// getRandomGradients(e) {
		// 	const gradient=[];
		// 	this.gradient = this.gradients[e % this.gradients.length]; 
		// 	return `background:linear-gradient(135deg, ${this.gradient[0]}, ${this.gradient[1]})`;
		// },
		getRandomGradients(e,k) {
		  const userId = e.userId; 
		  if (this.colorCache[userId]) {
		    return `background:linear-gradient(135deg, ${this.colorCache[userId][0]}, ${this.colorCache[userId][1]})`;
		  }
		  const index = k % this.gradients.length;
		  // console.log('index', index);
		  const gradient = this.gradients[index];
		  this.colorCache[userId] = gradient;
		  return `background:linear-gradient(135deg, ${gradient[0]}, ${gradient[1]})`;
		},
		getFirstLetter(name) {
			return name ? name.charAt(0).toUpperCase() : '?';// 返回第一个字母并转换为大写  
		},
		onPoints() {
			// console.log(this.pointimg,'this.pointimg')
			window.open(`https://community.goodwe.com${this.pointimg}`, '_blank');
		},
		onMaterials() {
			// console.log(this.materials,'this.materials')
			window.open(`https://community.goodwe.com${this.materials}`, '_blank');
		},
		xiaZai() {
			if(this.users) {
				// window.open(`https://goodwe.jsydl.com.cn/user/pdf/${this.$qu('kouling')}`, '_blank');
				window.open(`https://community.goodwe.com/api/user/pdf/${this.$qu('kouling')}`);
			}
		},
		
		xiaoxi() {
			var that=this
			let data = {
				pageNum: 0,
				pageSize: 10,
				type: 2
			}
			message(data).then(shu => {
				
				let arr = []
				if(shu.code=='200') {
					arr = shu.data.content.map(item => `${item.title}`);
				}
				
				let dengji = that.getMedalType(that.infos.plusLevel)
				// console.log(that.infos.plusLevel,'dengji')
				let jifen = 0
				// if(this.users.plusLevel == 0) {
				// 	dengji = 
				// }else if(this.users.plusLevel == 1) {
				// 	dengji = 
				// }else if(this.users.plusLevel == 2) {
				// 	dengji = 
				// }
				that.messageList = [`${that.gudingziduan.plus.Hello} ${that.users.account}, ${that.gudingziduan.plus.Yourcurrent}${dengji} ${that.gudingziduan.plus.Youneed} ${that.infos.upgradePoint} ${that.gudingziduan.plus.pointstoachieve} ${that.infos.plusExpirationDate}.`,...arr]
				
			})

		},
		getMedalType(zt) {
		  const medalTypes = {
			0: 'Bronze',
			1: 'Silver',
			2: 'Gold'
		  };
		  return medalTypes[zt] || 'unknown'; // 如果zt不在映射中，返回'unknown'
		},
		postTiezi(){
			let par3 = {
			  // "group": "",
			  // "keyword": "",
			  "pageNum": 0,
			  "pageSize": 5,
			  // "sort": "",
			  // "tags": "",
			  "showPlus": 1,
			  // "time": 0,
			  // "type": ""
			}
			plustie(par3).then(shu => {
				this.tiezilist = shu.data.content
				
			})
		},
		// postResource() {
		// 	let par = {
		// 	  "pageNum": 0,
		// 	  "pageSize": 5,
		// 	}
		// 	plusResource(par).then(shu => {
		// 		if(shu.code=='200') {
		// 			this.resourceList = shu.data.content
		// 		}
				
		// 	})
		// },
		CSH() {
			plusInfo().then(shu => {
				if(shu.code=='200') {
					this.infos = shu.data
					this.user()
					// this.infos.process=Number(this.infos.process);
					// console.log(this.infos.process,'this.infos.process')
				}
				
			})
			plusMaterials().then(shu => {
				if(shu.code=='200') {
					this.materials = shu.data
				}
				
			})
			plussPoint().then(shu => {
				if(shu.code=='200') {
					this.pointimg = shu.data
				}
				
			})
			
		},
		user2(){
			var that=this
			myxiangqing().then(res => {
				if(res.data.plusRegion=='hk' && that.$store.state.yuyan=='PK'){
					that.gaise=1
				}else{
					that.gaise=0
				}
			})
		},
		user() {
			allUser().then(shu => {
				if(shu.code=='200') {
					this.users = shu.data
					this.xiaoxi()
					// this.playlistlies()
					this.getPlaylists()
				}
			})
			
		}
	}
}
</script>

<style lang="scss" scoped>
body {
	background-color: #F6F6F8 !important;
}
.gaiyanse{
	color: #e70a16 !important;
	 text-decoration: underline;
	  /* 可选：设置下划线颜色（和文字同色） */
	  text-decoration-color: #e70a16;
}
.fadeup {
	animation: fadeInUp 1s ease both;
	animation-delay: 0.4s;
}

.plus_d {
	::v-deep .gonggao {
		.gonggao1 {
			width: 26px;
			height: 26px;
			background: linear-gradient(146deg, #ff785c 0%, #e70a16 100%);
		}

		.slide .text {
			padding-right: 70px;
		}



		.el-carousel__indicators--horizontal {
			display: none;
		}

		.el-carousel__arrow--left {
			position: absolute;
			right: 34px;
			left: unset;
			width: 28px;
			height: 28px;
			background: #ffffff;
			color: #82858E;
		}

		.el-carousel__arrow--right {
			position: absolute;
			right: 0;
			left: unset;
			width: 28px;
			height: 28px;
			background: #ffffff;
			color: #82858E;
		}
	}

	.plus_zhu {

		.rel {

			.progress {
				position: relative;


				.icon {
					bottom: 100%;
					width: .28rem;
					height: .28rem;
					min-height: 20px;
					min-width: 20px;
					transform: translateX(100%);
				}

				.icon2 {left: 15%;}
				.icon1 {left: 70%;}
			}

		}

		.plus_zhul {
			width: 49%;

			.pz1 {
				width: 1.82rem;
				height: 2.09rem;
			}

			.downl {

				img {
					width: 43px;
					height: .6rem;
					object-fit: contain;
					transition: .5s;
				}

				.item {
					text-align: center;

					&:hover span {
						color: #e70a16;
					}

					&:hover img {
						transform: rotateY(180deg);
					}
				}
			}
		}

		.plus_zhur {
			width: 48%;
		}
	}

	.plus_db {
		.plus_dbll {
			width: 65%;
		}

		::v-deep .plus_dbrr {
			width: 32.5%;

			ul li .el-image img {
				transition: .5s;
			}

			ul li:hover .el-image img {
				transform: scale(1.05);
			}
		}

	.group-ht-nr {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		font-weight: normal;
	}
	

		.ulss li {
			.shouzimu {
				width: .25rem;
				height: .25rem;
				min-height: 20px;
				min-width: 20px;
				border-radius: 50%;
				background: #ff9680;
				flex-shrink: 0;
			}

			.time {
				flex-shrink: 0;
			}
		}

		.ulss li:last-child {
			border-bottom: none !important;
		}

		.plus_dbrr {
			.pd_tu {
				width: 1.60rem;

				::v-deep .el-image {
					overflow: visible;
				}
			}

		}



	}
}

// ==========================================================================================================================================================================
// 响应式
@media screen and (max-width:767px) {
	.plus_zhu {flex-wrap: wrap;}
	.plus_d .plus_zhu .plus_zhul {width: 100%;}
	.plus_d .plus_zhu .plus_zhul .zhulTop {flex-wrap: wrap;}
	.plus_d .plus_zhu .plus_zhul .pz1 {margin: auto;}
	.plus_d .plus_zhu .plus_zhul .zhulTopInfo {width: 100%; margin: 0; padding-top: .3rem;}
	.plus_d .plus_zhu .plus_zhur {width: 100%;}

	.plus_db {flex-wrap: wrap;}
	.plus_d .plus_db .plus_dbll {width: 100%;}
	.plus_d .plus_db .plus_dbrr {width: 100%; margin-top: .3rem;}
}

</style>